import React from 'react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-b border-crema bg-blanco" data-id="element-80" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-xl px-4 py-6 sm:py-9" data-id="element-81" data-mp="4vryttha25or">
        <div className="rounded-2xl border-2 border-petroleo/60 bg-petroleo/5 p-4 text-center" data-id="element-82" data-mp="9ttj2hqfwb1t">
          <p className="font-hand text-[1.7rem] leading-none text-terracota sm:text-4xl" data-id="element-83" data-mp="etz4hg6491bg">Tu inversión está protegida</p>
          <h2 id="garantia" className="mt-1 font-serif text-2xl font-bold text-azul sm:text-3xl" data-id="element-84" data-mp="jrhhbhn980oq">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="mt-1.5 text-sm leading-snug text-azul/80" data-id="element-85" data-mp="skugh1bwvyj9">
            Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si considerás que
            el sistema no es adecuado para vos, podés solicitar un reembolso dentro
            del período establecido según los términos de devolución.
          </p>
        </div>
      </div>
    </section>;
}